import API from '../utils/api';
import { call, put, takeEvery } from 'redux-saga/effects';

import {
    GET_ADMINS_REQUESTED,
    ADD_ADMIN_REQUESTED,
    UPDATE_ADMIN_REQUESTED,
    DELETE_ADMIN_REQUESTED,
} from '../actions/types';

import {
    getAdminsSuccess,
    getAdminsFailed,
    addAdminSuccess,
    addAdminFailed,
    updateAdminSuccess,
    updateAdminFailed,
    deleteAdminSuccess,
    deleteAdminFailed,
} from '../actions/adminAction';

export function* getAdmins() {
    try {
        const response = yield call(API.getData, 'users/role/admins');
        yield put(getAdminsSuccess(response));
    } catch (error) {
        yield put(getAdminsFailed(error));
    }
}

export function* addAdmin({ payload }) {
    try {
        const response = yield call(API.postData, 'users/admins', { ...payload, isCellLeader: !!payload.isCellLeader });
        yield put(addAdminSuccess(response));
    } catch (error) {
        yield put(addAdminFailed(error));
    }
}

export function* updateAdmin({ payload }) {
    try {
        const response = yield call(API.putData, `users/${payload.id}/admin`, { ...payload, isCellLeader: !!payload.isCellLeader });
        yield put(updateAdminSuccess(response));
    } catch (error) {
        yield put(updateAdminFailed(error));
    }
}

export function* deleteAdmin({ payload }) {
    try {
        const response = yield call(API.deleteData, `users/${payload}?role=2`);
        yield put(deleteAdminSuccess({ ...response, id: payload }));
    } catch (error) {
        yield put(deleteAdminFailed(error));
    }
}

export default function* adminSaga() {
    yield takeEvery(GET_ADMINS_REQUESTED, getAdmins);
    yield takeEvery(ADD_ADMIN_REQUESTED, addAdmin);
    yield takeEvery(UPDATE_ADMIN_REQUESTED, updateAdmin);
    yield takeEvery(DELETE_ADMIN_REQUESTED, deleteAdmin);
}
